// The "Pastores" order of a collaborator, from the title in the NAME prefix. The same rule as
// pastorRankOf() in the API (packages/admin-mobifull-api/src/pastor-rank.ts, which the importer
// and the API default use): normalize to NFC, fold accents, strip leading non-letters, take the first whole word;
// pr | pra | pastor | pastora 1, ev | evangelista 2, pb | presbitero 3, anything else 4. Here it only prefills the
// form while the admin has not chosen a value; the API decides what is stored.
export const PASTOR_RANKS = [1, 2, 3, 4] as const

const FOLD_FROM = 'ABCDEFGHIJKLMNOPQRSTUVWXYZÁÀÂÃÄÅÉÈÊËÍÌÎÏÓÒÔÕÖÚÙÛÜÇÑÝáàâãäåéèêëíìîïóòôõöúùûüçñýÿ'
const FOLD_TO = 'abcdefghijklmnopqrstuvwxyzaaaaaaeeeeiiiiooooouuuucnyaaaaaaeeeeiiiiooooouuuucnyy'
const FOLD = new Map([...FOLD_FROM].map((ch, i) => [ch, FOLD_TO[i]]))

const RANK_OF_WORD = new Map([
  ['pr', 1],
  ['pra', 1],
  ['pastor', 1],
  ['pastora', 1],
  ['ev', 2],
  ['evangelista', 2],
  ['pb', 3],
  ['presbitero', 3],
])

const FIRST_WORD = /^[^a-z]*([a-z]+)/

export function pastorRankOf(name: string): number {
  let folded = ''
  for (const ch of name.normalize('NFC')) {
    folded += FOLD.get(ch) ?? ch
  }
  const word = FIRST_WORD.exec(folded)?.[1]
  return (word && RANK_OF_WORD.get(word)) || 4
}
